import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/suppliers/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/suppliers/Model"
import { CrudProvider } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"
import { useState } from "react"

export default function SupplierList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/pos/dashboard" }, { label: "Supplier" }]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Suppliers</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <SupplierTable />
      </CrudProvider>
    </>
  )
}

function SupplierTable() {
  return (
    <>
      <CustomTable
        label="Supplier"
        columns={columns}
        apiPath="supplier"
        showImport={true}
        onExport={true}
      />

      <Modal />
    </>
  )
}
